import { useState, useEffect, useCallback } from 'react'
import { getSharedNote, upsertSharedNote } from '../supabase/api'

export function useSharedNotes(pairId, weekNumber, userId) {
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  const fetchNote = useCallback(async () => {
    if (!pairId || !weekNumber) {
      setNote('')
      setLoading(false)
      return
    }
    try {
      setLoading(true)
      setNote('') // clear stale note immediately before fetch
      const data = await getSharedNote(pairId, weekNumber)
      setNote(data?.content || '')
    } catch {
      setNote('')
    } finally {
      setLoading(false)
    }
  }, [pairId, weekNumber])

  useEffect(() => {
    fetchNote()
  }, [fetchNote])

  const saveNote = async (content) => {
    if (!pairId) return
    setSaving(true)
    try {
      await upsertSharedNote(pairId, weekNumber, content, userId)
      setNote(content)
    } finally {
      setSaving(false)
    }
  }

  return { note, setNote, loading, saving, saveNote, refetch: fetchNote }
}